import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
import type { Bi } from '../../data/sectors';
import { overviewCapacity as c } from '../../data/platformOverview';
const EASE = [0.23, 1, 0.32, 1] as const;
const reveal = {
  initial: {
    opacity: 0,
    y: 12
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-80px'
  },
  transition: {
    duration: 0.3,
    ease: EASE
  }
};
export function PlatformOverviewCapacity() {
  const {
    lang
  } = useLanguage();
  const pick = (b: Bi) => lang === 'FR' ? b.fr : b.en;
  return <section className="relative overflow-hidden bg-white border-t border-[#EEF0F4] px-6 py-20 lg:py-28" aria-labelledby="platform-capacity-title" data-id="element-5610" data-mp="2khdgchfp2c6w">
      <div className="pointer-events-none absolute left-1/2 bottom-0 -translate-x-1/2 w-[760px] h-[320px] rounded-full bg-[#F1F0FD] opacity-60 blur-[140px]" aria-hidden="true" data-id="element-5611" data-mp="2tgqjyth506jp" />
      <div className="relative max-w-[1180px] mx-auto" data-id="element-5612" data-mp="13b74a7t8hhyv">
        <motion.div {...reveal} className="max-w-[760px]" data-id="element-5613" data-mp="13crwvrvzmqu3">
          <p className="font-sans text-[12.5px] font-semibold tracking-[0.28em] uppercase text-[#4F46E5]" data-id="element-5614" data-mp="z9lskpsfr9q9">{pick(c.eyebrow)}</p>
          <h2 id="platform-capacity-title" className="mt-5 font-serif text-[2rem] sm:text-[2.5rem] lg:text-[2.8rem] leading-[1.06] tracking-tight" data-id="element-5615" data-mp="ubajih9yt393">
            {c.headline.map(l => <span key={l.text.fr} className={`block ${l.accent ? 'text-[#4F46E5]' : 'text-[#121A3A]'}`} data-id="element-5616" data-mp="1my4qcbdv0443">{pick(l.text)}</span>)}
          </h2>
        </motion.div>

        <ol className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-10" data-id="element-5617" data-mp="1d93emxeck8vx">
          {c.principles.map((p, i) => <motion.li key={p.n} {...reveal} transition={{
          duration: 0.3,
          delay: i * 0.05,
          ease: EASE
        }} className="border-t border-[#E4E3F2] pt-5" data-id="element-5618" data-mp="189qqm9bqovrr" data-mpi={i}>
              <p className="font-sans text-[12px] font-semibold tracking-[0.2em] text-[#4F46E5]" data-id="element-5619" data-mp="20z7fwy42bwjr">
                {p.n} <span className="mx-1 text-[#C9C6F5]" data-id="element-5620" data-mp="3v7b8pm653rn2">—</span> <span className="uppercase" data-id="element-5621" data-mp="3v7kzvd2x84uc">{pick(p.title)}</span>
              </p>
              <p className="mt-3 font-sans text-[15px] text-[#3A4258] leading-relaxed" data-id="element-5622" data-mp="327dnwnsu19h">{pick(p.text)}</p>
            </motion.li>)}
        </ol>

        <motion.div {...reveal} className="mt-24 text-center" data-id="element-5623" data-mp="3lff6byx0tfd1">
          <p className="max-w-[760px] mx-auto font-serif text-[1.55rem] sm:text-[1.9rem] lg:text-[2.2rem] leading-[1.22] tracking-tight" data-id="element-5624" data-mp="3qertylvpuqgo">
            {c.statement.map((s, i) => <span key={s.fr} className={`block ${i === c.statement.length - 1 ? 'text-[#4F46E5]' : 'text-[#121A3A]'}`} data-id="element-5625" data-mp="3gj7yu1oz7vsz" data-mpi={i}>{pick(s)}</span>)}
          </p>
          <Link to="/request-demo" className="mt-10 inline-flex w-full sm:w-auto items-center justify-center gap-3 rounded-xl bg-[#4F46E5] px-10 py-3.5 font-sans text-[16px] font-medium text-white shadow-[0_14px_30px_-14px_rgba(79,70,229,0.7)] hover:bg-[#4338CA] transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4F46E5] focus-visible:ring-offset-2" data-id="element-5626" data-mp="37h75hfwv5twl">
            {pick(c.cta)}
            <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-5627" data-mp="1awiquwv7dt3b" />
          </Link>
        </motion.div>
      </div>
    </section>;
}